import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { siteInfo } from '@/mocks/siteInfo';
import { categories } from '@/mocks/categories';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
    window.scrollTo(0, 0);
  }, [location.pathname]);

  const mainCategories = categories.filter(c => c.slug !== 'all').slice(0, 5);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-background-50 shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
            <span className={`text-xl font-bold transition-colors duration-300 ${
              isScrolled ? 'text-primary-500' : 'text-background-50'
            }`}>
              {siteInfo.name}
            </span>
            <span className={`hidden sm:inline text-xs px-2 py-0.5 rounded-full transition-colors duration-300 ${
              isScrolled ? 'bg-primary-100 text-primary-700' : 'bg-background-50/20 text-background-50'
            }`}>
              独家爆料
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            <Link
              to="/"
              className={`px-3 py-2 text-sm rounded-lg transition-colors duration-200 whitespace-nowrap ${
                location.pathname === '/'
                  ? isScrolled ? 'bg-primary-100 text-primary-700 font-medium' : 'bg-background-50/20 text-background-50 font-medium'
                  : isScrolled ? 'text-foreground-700 hover:bg-background-100' : 'text-background-50/90 hover:bg-background-50/10'
              }`}
            >
              首页
            </Link>
            {mainCategories.map(cat => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`px-3 py-2 text-sm rounded-lg transition-colors duration-200 whitespace-nowrap ${
                  location.pathname.includes(`/category/${cat.slug}`)
                    ? isScrolled ? 'bg-primary-100 text-primary-700 font-medium' : 'bg-background-50/20 text-background-50 font-medium'
                    : isScrolled ? 'text-foreground-700 hover:bg-background-100' : 'text-background-50/90 hover:bg-background-50/10'
                }`}
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`px-3 py-2 text-sm rounded-lg transition-colors duration-200 whitespace-nowrap ${
                location.pathname === '/about'
                  ? isScrolled ? 'bg-primary-100 text-primary-700 font-medium' : 'bg-background-50/20 text-background-50 font-medium'
                  : isScrolled ? 'text-foreground-700 hover:bg-background-100' : 'text-background-50/90 hover:bg-background-50/10'
              }`}
            >
              关于我们
            </Link>
          </div>

          <div className="flex items-center gap-3">
            <button className={`w-8 h-8 flex items-center justify-center rounded-full transition-colors duration-200 cursor-pointer ${
              isScrolled ? 'text-foreground-700 hover:bg-background-100' : 'text-background-50/90 hover:bg-background-50/10'
            }`}>
              <i className="ri-search-line text-lg"></i>
            </button>
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className={`md:hidden w-8 h-8 flex items-center justify-center rounded-full transition-colors duration-200 cursor-pointer ${
                isScrolled ? 'text-foreground-700 hover:bg-background-100' : 'text-background-50/90 hover:bg-background-50/10'
              }`}
            >
              <i className={`text-lg ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
            </button>
          </div>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <div className="px-4 py-3 flex flex-col gap-1">
            <Link
              to="/"
              className={`px-3 py-2.5 text-sm rounded-lg transition-colors duration-200 ${
                location.pathname === '/' ? 'bg-primary-100 text-primary-700 font-medium' : 'text-foreground-700 hover:bg-background-100'
              }`}
            >
              首页
            </Link>
            {mainCategories.map(cat => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`px-3 py-2.5 text-sm rounded-lg transition-colors duration-200 ${
                  location.pathname.includes(`/category/${cat.slug}`) ? 'bg-primary-100 text-primary-700 font-medium' : 'text-foreground-700 hover:bg-background-100'
                }`}
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`px-3 py-2.5 text-sm rounded-lg transition-colors duration-200 ${
                location.pathname === '/about' ? 'bg-primary-100 text-primary-700 font-medium' : 'text-foreground-700 hover:bg-background-100'
              }`}
            >
              关于我们
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}